(() => {
  const railStates = new WeakMap();
  let scanScheduled = false;

  const setActiveDot = ({ dots, index }) => {
    dots.forEach((dot, dotIndex) => {
      const isActive = dotIndex === index;
      dot.classList.toggle('is-active', isActive);

      if (isActive) {
        dot.setAttribute('aria-current', 'true');
        return;
      }

      dot.removeAttribute('aria-current');
    });
  };

  const hasSameCards = ({ currentCards, nextCards }) => {
    return currentCards.length === nextCards.length
      && currentCards.every((card, index) => {
        return card === nextCards[index];
      });
  };

  const clearRailState = (rail) => {
    const state = railStates.get(rail);
    if (!state) return;

    state.observer?.disconnect();
    state.pagination?.remove();
    railStates.delete(rail);
  };

  const upgradeRail = (rail) => {
    const cards = Array.from(rail.children);
    const currentState = railStates.get(rail);

    if (currentState && hasSameCards({ currentCards: currentState.cards, nextCards: cards })) {
      return;
    }

    clearRailState(rail);
    rail.dataset.syRailReady = 'true';
    rail.setAttribute('aria-roledescription', 'carousel');

    if (cards.length < 2) {
      railStates.set(rail, { cards, observer: undefined, pagination: undefined });
      return;
    }

    const pagination = document.createElement('div');
    pagination.className = 'sy-rail-pagination';
    pagination.setAttribute('role', 'group');
    pagination.setAttribute('aria-label', 'Carousel pagination');

    const dots = cards.map((card, index) => {
      const dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'sy-rail-dot';
      dot.setAttribute('aria-label', `Show slide ${index + 1} of ${cards.length}`);
      dot.addEventListener('click', () => {
        const behavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
        setActiveDot({ dots, index });
        card.scrollIntoView({ behavior, block: 'nearest', inline: 'start' });
      });
      pagination.append(dot);
      return dot;
    });

    rail.insertAdjacentElement('afterend', pagination);
    setActiveDot({ dots, index: 0 });

    if (!('IntersectionObserver' in window)) {
      railStates.set(rail, { cards, observer: undefined, pagination });
      return;
    }

    const visibility = new Map(cards.map((card) => {
      return [card, 0];
    }));
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        visibility.set(entry.target, entry.intersectionRatio);
      });

      const activeIndex = cards.reduce((bestIndex, card, index) => {
        const bestRatio = visibility.get(cards[bestIndex]) || 0;
        const cardRatio = visibility.get(card) || 0;
        return cardRatio > bestRatio ? index : bestIndex;
      }, 0);

      setActiveDot({ dots, index: activeIndex });
    }, {
      root: rail,
      threshold: [0.25, 0.5, 0.75, 0.95],
    });

    cards.forEach((card) => {
      observer.observe(card);
    });
    railStates.set(rail, { cards, observer, pagination });
  };

  const scanRails = () => {
    scanScheduled = false;
    document.querySelectorAll('[data-sy-rail]').forEach((rail) => {
      upgradeRail(rail);
    });
  };

  const scheduleScan = () => {
    if (scanScheduled) return;
    scanScheduled = true;
    window.requestAnimationFrame(scanRails);
  };

  document.addEventListener('shopify:section:load', scheduleScan);
  new MutationObserver(scheduleScan).observe(document.documentElement, {
    childList: true,
    subtree: true,
  });
  scheduleScan();
})();
